import { useState, useEffect } from 'react';
import useStore from '../store/useStore';

/**
 * Custom hook to check if the current dashboard data is stale
 * @returns {boolean} True if dashboard data is stale
 */
export function useDashboardStale() {
  const currentDashboard = useStore((state) => state.currentDashboard);
  const dashboardLastUpdates = useStore((state) => state.dashboardLastUpdates);
  const wsConnected = useStore((state) => state.wsConnected);
  const [currentTime, setCurrentTime] = useState(new Date());

  // Update current time every 10 seconds to recalculate staleness
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 10000); // Update every 10 seconds

    return () => clearInterval(interval);
  }, []);

  // Check if dashboard data is stale
  if (!currentDashboard || !wsConnected) return false;

  const lastUpdate = currentDashboard?.id ? dashboardLastUpdates[currentDashboard.id] : null;
  if (!lastUpdate) return false;

  const staleThresholdMinutes = currentDashboard.stale_threshold_minutes || 5;
  const lastUpdateDate = new Date(lastUpdate);
  const minutesSinceUpdate = (currentTime - lastUpdateDate) / 1000 / 60;

  return minutesSinceUpdate > staleThresholdMinutes;
}
